import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import FormSection from "../../../../common/components/functional/formSection/FormSection";
import OverlappingOrderRowsError from "../../OverlappingOrderRowsError";
import { ShiftDetails2 } from "../../orderAPI";
import { AutocompleteOptions, ValidationError } from "../../orderTypes";
import {
  CancelAssignmentCallback,
  CancelAllAssignmentsCallback,
  HandleCustomerCCChangeFunction,
  HandleFillShiftChangeFunction,
  HandleFlexibleStartTimeChangeFunction,
  HandleTimeChangeFunction,
} from "../../types/editOrder";
import {
  hasCancelledShiftByTalent,
  isBundleOrder,
  sortShiftRowsByTalentAndStart,
} from "../../utils";
import { ShiftInfoHeadersRow } from "./ShiftInfoHeadersRow";
import { ShiftInfoRow } from "./ShiftInfoRow";

type Props = {
  isReadOnly: boolean;
  isAutomatchingOn: boolean;
  isExpertAuthorizedToEdit: boolean;
  rows: ShiftDetails2[];
  options: AutocompleteOptions;
  validationErrors: ValidationError[];
  handleTimeChange: HandleTimeChangeFunction;
  handleCustomerCCChange: HandleCustomerCCChangeFunction;
  handleFillShiftChange: HandleFillShiftChangeFunction;
  handleFlexibleStartTimeChange: HandleFlexibleStartTimeChangeFunction;
  cancelAssignment: CancelAssignmentCallback;
  cancelAllAssignments: CancelAllAssignmentsCallback;
};

export const ShiftInfo = ({
  isReadOnly,
  isAutomatchingOn,
  isExpertAuthorizedToEdit,
  rows,
  options,
  handleTimeChange,
  handleCustomerCCChange,
  validationErrors,
  handleFillShiftChange,
  handleFlexibleStartTimeChange,
  cancelAssignment,
  cancelAllAssignments,
}: Props) => {
  const { t } = useTranslation("order");

  const shiftDetailsLabel =
    rows.length > 1 ? "shiftDetailsPlural" : "shiftDetails";

  const isBundle = isBundleOrder(rows);
  const sortedRows = sortShiftRowsByTalentAndStart(rows);
  const cancelledByTalent = hasCancelledShiftByTalent(rows);

  return (
    <FormSection title={t(shiftDetailsLabel)}>
      <Grid sx={{ overflowX: "auto" }}>
        <Grid
          container
          item
          xs={12}
          justifyContent="flex-end"
          direction="row"
          minWidth="800px"
        >
          <ShiftInfoHeadersRow />
          {sortedRows.map((row: ShiftDetails2, i) => (
            <ShiftInfoRow
              isReadOnly={isReadOnly}
              isAutomatchingOn={isAutomatchingOn}
              isExpertAuthorizedToEdit={isExpertAuthorizedToEdit}
              key={row.id}
              row={row}
              options={options}
              validationErrors={validationErrors}
              handleTimeChange={handleTimeChange}
              handleCustomerCCChange={handleCustomerCCChange}
              handleFillShiftChange={handleFillShiftChange}
              handleFlexibleStartTimeChange={handleFlexibleStartTimeChange}
              cancelAssignment={
                row.assignedTalent ? cancelAssignment : () => {}
              }
              isBundle={isBundle}
              hasCancelledShiftByTalent={cancelledByTalent}
              cancelAllAssignments={cancelAllAssignments}
            />
          ))}
        </Grid>
      </Grid>
      <OverlappingOrderRowsError
        validationErrors={validationErrors}
        position={{ left: "395px", bottom: "8px" }}
      />
    </FormSection>
  );
};
